import { styled } from "@mui/material/styles";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";

export const StyledHeader = styled("div")(({ theme }) => ({
  height: theme.spacing(3),
  width: "100%",
  background: theme.palette.primary.light,
  color: "white",
  fontWeight: "bold",
  textAlign: "left",
  paddingTop: theme.spacing(0.5)
}));

export const StyledContainer = styled("div")(({ theme }) => ({
  border: `1px solid grey`,
  position: "fixed",
  top: theme.spacing(16),
  bottom: theme.spacing(10),
  right: theme.spacing(5),
  left: theme.spacing(5)
}));

export const StyledInnerContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(2),
  overflow: "auto",
  position: "fixed",
  top: theme.spacing(28),
  bottom: theme.spacing(12),
  right: theme.spacing(6),
  left: theme.spacing(6)
}));

export const StyledHeaderText = styled("span")(({ theme }) => ({
  marginLeft: theme.spacing(1)
}));

export const StyledFallback = styled(AssignmentTurnedInIcon)(({ theme }) => ({
  width: theme.spacing(60),
  height: theme.spacing(60),
  color: "#D3D3D3"
}));

export default {
  StyledContainer,
  StyledHeader,
  StyledHeaderText,
  StyledFallback
};
